export default __webpack_public_path__ + "static/media/heroku.b7e7f910.svg";